import { render } from "./ProfileTemplateList.vue?vue&type=template&id=0837152f&scoped=true"
import script from "./ProfileTemplateList.vue?vue&type=script&lang=js"
export * from "./ProfileTemplateList.vue?vue&type=script&lang=js"

import "./ProfileTemplateList.vue?vue&type=style&index=0&id=0837152f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0837152f"]])

export default __exports__